import _ from 'lodash';
import React from 'react';
import { Button } from 'react-bootstrap';

export default function TrashActionBtn(props) {
  
  const onClick = async () => {
    if (_.isFunction(props.deleteAction)) {
      props.deleteAction()
    }
  }

  return (
    <Button
      // variant={'outline-dark'}
      size={props.size || 'lg'}
      onClick={onClick}
      type="button"
      className={`bigButton font16 ${props.bigBtnClass}`}
      title={props.actionWord}
    >
      {props.buttonIcon}
      {props.actionWord}
    </Button>

  );
}
